import { render, staticRenderFns } from "./edit-notification.vue?vue&type=template&id=6cca8ab3&"
import script from "./edit-notification.vue?vue&type=script&lang=js&"
export * from "./edit-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports